<template>
  <div class="control-panel">
    <font-awesome-icon
      icon="times"
      size="2x"
      class="float-right control-btn"
      @click="closePanel()"
    />
    <h4 class="mt-1 mb-5">{{ snapshot.name }}</h4>
    <b-row align-h="center">
      <b-col cols="6" class="text-left">
        <span class="mr-3">{{ $t('set-project-as-default', [snapshot.name]) }}</span>
      </b-col>
      <b-col cols="6" class="text-right">
        <toggle-button
          :sync="true"
          v-model="defaultSnapshot"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';
import ControlPanelMixin from '@/mixins/ControlPanel';
import config from '@/config';
import ToasterMixin from '@/mixins/Toaster';
import eventBus from '@/components/utils/slideout-panel/eventBus';

export default {
  name: 'ProjectSettingsPanel',
  mixins: [
    ToasterMixin,
    ControlPanelMixin,
  ],
  props: {
    snapshot: {
      type: Object,
      required: true,
    },
  },
  computed: {
    defaultSnapshot: {
      get() {
        return this.snapshot.is_default;
      },
      set(value) {
        this.changeDefaultProject(value);
      },
    },
  },
  methods: {
    async changeDefaultProject(isDefault) {
      try {
        const url = new URL(
          config.ICOOL.API.DEFAULT_SNAPSHOT_PATH(this.snapshot.id),
          config.ICOOL.BACKEND_HOST,
        ).href;
        const response = await axios.post(url, { is_default: isDefault });
        eventBus.$emit('refreshSnapshots');
        this.showToast(this.$t('user-update'), this.$t('default-project-set'), 'success');
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>

</style>
